import * as yup from 'yup';

export type BuscadorNotariosFormValues = {
	name: string;
	surname: string;
	domicilio: string;
	poblacion: string;
	cp: string;
};

export const defaultValues: BuscadorNotariosFormValues = {
	name: '',
	surname: '',
	domicilio: '',
	poblacion: '',
	cp: '',
};

export const formSchema = yup.object({
	name: yup.string().trim().required('El nombre es obligatorio'),
	surname: yup.string().trim().required('El apellido es obligatorio'),
	domicilio: yup.string().trim(),
	poblacion: yup.string().trim(),
	cp: yup.string().trim(),
});
